import * as React from 'react';
import { IAILWorkflowConnectProps } from './ail-workflow-container';
import { Workflow } from '../../../components';
import { AILDataUploadContainer } from '../ail-data-upload';
import { AILConfigContainer } from '../ail-config';
import { AILDataSaveContainer } from '../ail-data-save';
import { DataLoadApi } from '../../../api';
import { DATA_LOAD_STAGE } from '../../../constants';
import * as Actions from '../../../actions';

/**
 * Activity-Indicator Links workflow manages transitions between data load flow components
 */
export class AILWorkflow extends React.Component<IAILWorkflowConnectProps> {
  public componentWillMount(): void {
    this.props.dispatch(Actions.UI.setDataLoadStage(DATA_LOAD_STAGE.DATA_UPLOAD_INITIAL));
  }

  public componentWillUnmount(): void {
    DataLoadApi.cancelDataLoad().request()
      .then((): void => {
        this.props.dispatch(Actions.Batch.clearAppState());
      })
      .catch((): void => {
        this.props.dispatch(Actions.Batch.clearAppState());
      });
  }

  public render(): JSX.Element {
    return (
      <Workflow
        stage={this.props.ui.stage}
        upload={<AILDataUploadContainer />}
        config={<AILConfigContainer />}
        result={<AILDataSaveContainer />}
      />
    );
  }
}
